import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { PRESSABLE } from '../../../styles/constants';
import IconHamburger from '../../icons/IconHamburger.svg';

export const Hamburger = styled(IconHamburger).attrs({ 'data-testid': 'Hamburger' })`
  ${PRESSABLE};
  color: ${ThemeColours.black};
  flex: 0 0 32px;
  height: 32px;
  transition-property: opacity, transform;

  &:hover {
    opacity: 0.6;
  }
`;
